import { CircleCheck, XCircleIcon } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useGetAllAnimalEventTypesQuery } from "@/features/events/animal-events/api/event-types-api.ts"
import { NEW_ANIMAL_EVENT_VIEW } from "@/features/events/animal-events/routes/route-list.ts"
import GestationCalendarActionButton from "@/features/gestational-calendar/components/gestation-calendar-action-button/gestation-calendar-action-button.tsx"
import {
  type CalendarActivity,
  type CalendarEventMetadata,
  type GestationCalendar,
} from "@/features/gestational-calendar/types/calendar-types.ts"
import { FP_QUERY_PARAMS } from "@/features/gestational-calendar/utils/gestation-calendar-consts.ts"

interface Props {
  calendarActivity: CalendarActivity
  gestationCalendar: GestationCalendar
}

export const GestationCard: React.FC<Props> = ({
  gestationCalendar,
  calendarActivity,
}) => {
  const metadata = calendarActivity.event.metadata as CalendarEventMetadata

  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data } = useGetAllAnimalEventTypesQuery({})
  const animalEventTypes = Object.values(data ?? {})
  const gestationPositiveEventType = animalEventTypes.find(
    (eventType) =>
      eventType.name == metadata.gestation_positive_animal_event_type_name,
  )
  const gestationNegativeEventType = animalEventTypes.find(
    (eventType) =>
      eventType.name == metadata.gestation_negative_animal_event_type_name,
  )

  const handleAddEvent = (animal_event_type?: string) => {
    if (!animal_event_type) {
      return
    }

    const searchParams = new URLSearchParams()
    searchParams.append(FP_QUERY_PARAMS.ANIMAL_ID, gestationCalendar.animal)
    searchParams.append(
      FP_QUERY_PARAMS.GESTATION_CALENDAR_ENTRY_ID,
      calendarActivity.id,
    )
    searchParams.append(
      FP_QUERY_PARAMS.GESTATION_CALENDAR_ID,
      gestationCalendar.id,
    )
    if (animal_event_type) {
      searchParams.append(FP_QUERY_PARAMS.EVENT_TYPE_ID, animal_event_type)
    }

    navigate(`${NEW_ANIMAL_EVENT_VIEW}?${searchParams.toString()}`)
  }

  return (
    <div className={"space-y-2.5"}>
      <GestationCalendarActionButton
        text={t("confirmGestation")}
        icon={<CircleCheck className={"text-green-600"} />}
        onClick={() => handleAddEvent(gestationPositiveEventType?.id)}
      />
      <GestationCalendarActionButton
        text={t("infirmGestation")}
        icon={<XCircleIcon className={"text-red-500"} />}
        onClick={() => handleAddEvent(gestationNegativeEventType?.id)}
      />
    </div>
  )
}
